import React from "react";
import { SourceListPanel } from "../../document/sourceListPanel/SourceListPanel";
import { DocumentPartTreeSelection } from "../DocumentPartTree";
import { useSourceListPage } from "./SourcesListPanelLoaderHook";

interface DocumentSourceListPageProps {
  headerName: string;
  documentPartTreeSelection: DocumentPartTreeSelection;
  idPartRoot?: string;
}
export const SourcesListPanelLoader: React.FunctionComponent<DocumentSourceListPageProps> = (props) => {
  const { documentSourceList } = useSourceListPage(props);

  return <SourceListPanel headerName={props.headerName} sourceList={documentSourceList} />;
};
